export * from './network'
export * from './utils'

// export interface IContextSetting {
//     _structureVersion?: string
//     identifier: string
//     updateTimestamp?: any
//     values: ConfigurationItem[] | ISpecies[]
// }

interface ConfigurationItem {
    identifier: string
    title: string 
    sortOrder: Number
    sortIndex?: Number
    color?: string
    displayOptions?: DisplayOptions 
}

interface DisplayOptions {
    additionalObjects?: boolean
    heading?: boolean
    shotRanges?: boolean
    usageInformation?: boolean
}

export interface ISpecies {
    contextId: string 
    identifier: string
    values: SpeciesValues[]
}

interface SpeciesValues {
    identifier: string
    iconName: string
    names: LanguageOptions
}

interface LanguageOptions {
    de: string
}


export function helloWorld() {
    console.log("HelloWorld!!")
}